<p class="form-error">
    <ng-content />
</p>
